<script setup lang="ts">import { computed as _computed } from 'vue';

import { TagDto } from '@/api';
import Vue, { ref, onBeforeMount } from 'vue';
import glossaryModule from '@/store/modules/business-glossary';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import BusinessGlossaryDrawer from '@/components/business-glossary/business-glossary-drawer/Business-Glossary-Drawer.vue';
import SEllipsisToolTip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';
import SIcon from '@/components/SIcon.vue';

interface TermProps {
  term: TagDto;
  noClickable?: boolean;
}
const props = defineProps({
  term: null,
  noClickable: { type: Boolean, default: false }
});

let terms: glossaryModule;

const elevation = ref(0);

const style = _computed(() => (props.noClickable ? 'cursor: default;' : 'cursor: pointer;'));

const setSelectedTerm = async () => {
  if (!props.noClickable) {
    Vue.prototype.$rightDrawer.setTitle(props.term.name);
    Vue.prototype.$rightDrawer.setComponent(BusinessGlossaryDrawer);
    await Vue.prototype.$rightDrawer.openDrawer();
    terms.setSelectedTerm(props.term);
  }
};

onBeforeMount(() => {
  terms = getModule(glossaryModule, store);
});
</script>

<template lang="pug">
v-chip.term.d-inline-flex.mr-1(
  v-bind="$attrs"
  v-on="$listeners"
  :class="`elevation-${elevation}`"
  outlined small
  @click.native.stop.prevent="setSelectedTerm"
  :style="style" )
  SIcon.mr-1( icon="icon-book-open" size="small" )
  SEllipsisToolTip.grey--text.font-weight-medium(:content="term.name")

</template>

<style lang="scss">
.theme--light {
  .v-chip.term.v-chip--outlined {
    background-color: var(--v-bgPrimary-base) !important;
    border-color: map-get($grey, 'lighten-3') !important;
    color: map-get($grey, 'base') !important;

    &:hover {
      background-color: var(--v-bgTertiary-base) !important;
      border-color: map-get($grey, 'lighten-3') !important;
    }
  }
}
</style>
